import {
    put,
    take,
    select,
} from 'redux-saga/effects'
import {
    countriesUpdated,
    curatedTagsUpdated,
} from '../reducers'
import { eventChannel } from 'redux-saga'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import {
    curatedTagsFirebasePath,
    flattenCuratedTags,
} from 'shared/curated-tags'

export const __dataLoader = (fb = firebase, variant = null) => emit => {
    let refCountries = fb.database().ref('translations/countries')
    let refCuratedTags = fb.database().ref(curatedTagsFirebasePath(variant))

    refCountries
        .on('value', snapshot => {
            if (!snapshot) return

            let countries = snapshot.val()
            // console.log('countries:', countries)

            if (countries) emit({ countries })
        })

    refCuratedTags
        .on('value', snapshot => {
            if (!snapshot) return

            let curatedTags = snapshot.val()
            emit({ curatedTags: flattenCuratedTags(curatedTags || {}) })
        })

    return () => {
        refCountries.off()
        refCuratedTags.off()
    }
}

export function* dataLoader() {
    const variant = yield select(state => state.ui && state.ui.variant)
    const channel = eventChannel(
        __dataLoader(firebase, variant)
    )

    while (true) {
        let { countries, curatedTags } = yield take(channel)
        if (countries) {
            yield put(countriesUpdated(countries))
        }
        if (curatedTags !== undefined) {
            yield put(curatedTagsUpdated(curatedTags))
        }
    }
}
